import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EbdaEduNavbar from "components/navbars/EbdaEduNavbar";
import { useLanguage } from "context/LanguageContext";
import { useTheme } from "context/ThemeContext";
import { useEffect, useState } from "react";
import { fetchTrainersRegistrations } from "services/ebdaedu/ebdaeduData";
import { cairoDate } from "utils/cairoDate";

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

const EbdaEduWatomsTrainerRegistrations = () => {
    const { darkMode } = useTheme();
    const { language } = useLanguage();
    const [data, setData] = useState([]);
    const [registerCount, setRegisterCount] = useState(0);
    const [page, setPage] = useState("general");
    const [unfilteredData, setUnfilteredData] = useState([]);
    const [numberSearch, setNumberSearch] = useState("");
    const [locationSearch, setLocationSearch] = useState("");

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await fetchTrainersRegistrations();

                setUnfilteredData(response);
                setRegisterCount(uniqueCount(response));
                setUnfilteredData(response);
                setRegisterCount(uniqueCount(response));
                const grouped = Object.values(
                    response.reduce((acc, item) => {

                        const key = `${item.subject.name}|${item.city}`;

                        if (!acc[key]) {
                            acc[key] = {
                                subject: item.subject.name,
                                city: item.city,
                                items: [],
                            };
                        }

                        acc[key].items.push(item);

                        return acc;
                    }, {})
                );

                grouped.sort((a, b) => {
                    const cityCompare = a.city.localeCompare(b.city);
                    if (cityCompare !== 0) return cityCompare;

                    const subjectCompare = a.subject.localeCompare(b.subject);
                    if (subjectCompare !== 0) return subjectCompare;

                    return 0;
                });
                setData(grouped);
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        }
        fetchData();
    }, []);

    const handleDownload = (cv) => {
        if (!cv) return;

        // in case cv stored as "uploads/cvs/xxx.pdf"
        const filename = cv.split("/").pop();
        const safe = encodeURIComponent(filename);

        const url = `${BASE_URL}/uploads/cvs/${safe}`;

        // force download
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
    };

    const togglePage = () => {
        if (page === "general") {
            setPage("detailed");
        } else {
            setPage("general");
        }
    }

    const uniqueCount = (arr) => {
        const seen = new Set(arr.map(item => item.id_number));
        return seen.size;
    };

    return (
        <div className={`min-h-screen flex flex-col items-center ${darkMode && 'bg-watomsBlue text-white'}`}>
            {/* Navbar */}
            <EbdaEduNavbar />
            {/* Main Body */}
            <div className={`w-[95%] shadow-lg rounded-2xl p-6 ${darkMode ? 'bg-blue-900' : 'bg-white'}`} dir={language ? "ltr" : "rtl"}>
                {/* header */}
                <div className="flex gap-4 items-center mb-4">
                    <h1 className={`text-2xl font-bold ${darkMode ? "text-white" : "text-gray-800"}`}>
                        {language ? "trainers Information:" : "بيانات المتقدمين:"}
                    </h1>
                    <h1 className={`text-xl font-bold ${darkMode ? "text-white" : "text-gray-800"}`}>
                        ({language ? "count:" : "العدد:"} {registerCount})
                    </h1>
                    <button onClick={togglePage}><FontAwesomeIcon icon={language ? faArrowLeft : faArrowRight} /></button>
                    <h1 className="font-bold">{page}</h1>
                    <button onClick={togglePage}><FontAwesomeIcon icon={language ? faArrowRight : faArrowLeft} /></button>
                    {page !== "general" && <input
                        type="text"
                        placeholder={language ? "Search by WhatsApp..." : "البحث برقم الواتساب..."}
                        value={numberSearch}
                        onChange={(e) => setNumberSearch(e.target.value)}
                        className="border px-3 py-2 rounded-lg shadow-sm w-64"
                    />}
                    {page !== "general" && <input
                        type="text"
                        placeholder={language ? "Search by City or Center..." : "البحث بالمركز او المحافظة..."}
                        value={locationSearch}
                        onChange={(e) => setLocationSearch(e.target.value)}
                        className="border px-3 py-2 rounded-lg shadow-sm w-64"
                    />}
                </div>
                <div className="overflow-x-auto flex flex-col gap-6">
                    {page === "general" ?
                        <table className="w-full border border-gray-200 rounded-lg">
                            <thead className="bg-gray-200 text-gray-700">
                                {/* Table Header */}
                                <tr>
                                    <th className="py-2 px-4 border">#</th>
                                    <th className="py-2 px-4 border">{language ? "Date" : "التاريخ"}</th>
                                    <th className="py-2 px-4 border">{language ? "Time" : "التوقيت"}</th>
                                    <th className="py-2 px-4 border">{language ? "Full Name" : "اسم المتقدم"}</th>
                                    <th className="py-2 px-4 border">Whatsapp</th>
                                    <th className="py-2 px-4 border">{language ? "Phone" : "المحمول"}</th>
                                    <th className="py-2 px-4 border">{language ? "City" : "المحافظة"}</th>
                                    <th className="py-2 px-4 border">{language ? "Certification" : "الشهادة"}</th>
                                    <th className="py-2 px-4 border">{language ? "subject" : "المادة"}</th>
                                    <th className="py-2 px-4 border">cv</th>
                                </tr>
                            </thead>
                            <tbody>
                                {unfilteredData.length > 0 ? (
                                    unfilteredData.map((user, index) => (
                                        <tr
                                            key={index}
                                            className={`transition duration-150 text-center ${darkMode ? 'bg-watomsBlue hover:bg-blue-900 text-white' : 'bg-white hover:bg-gray-50'}`}
                                        >
                                            <td className="py-2 px-4 border">{unfilteredData.length - index}</td>
                                            <td className="py-2 px-4 border">{cairoDate(user.created_at).split(",")[0].trim()}</td>
                                            <td className="py-2 px-4 border">{cairoDate(user.created_at).split(",")[1].trim()}</td>
                                            <td className="py-2 px-4 border">{user.firstName} {user.secondName} {user.thirdName} {user.fourthName}</td>
                                            <td className="py-2 px-4 border">{`+2${user.whatsappNumber}`}</td>
                                            <td className="py-2 px-4 border">{`+2${user.phoneNumber}`}</td>
                                            <td className="py-2 px-4 border">{user.city}</td>
                                            <td className="py-2 px-4 border">{user.certification}</td>
                                            <td className="py-2 px-4 border">{user.subject.name}</td>
                                            {user.cv ? <td
                                                className={`py-2 px-4 border cursor-pointer underline ${darkMode ? "text-yellow-400" : "text-blue-600"}`}
                                                onClick={() => handleDownload(user.cv)}
                                            >
                                                cv
                                            </td> : <td
                                                className={`py-2 px-4 border ${darkMode ? "text-white" : "text-black"}`}
                                            >
                                                لا يوجد
                                            </td>}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="text-center py-4 text-gray-500">
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        : data.map(group => {
                            const filteredItems = group.items.filter(user => {
                                const number = numberSearch.trim();
                                const location = locationSearch.trim();

                                return (user.whatsappNumber.toString().includes(number) && user.city.toString().includes(location));
                            });

                            // If after filtering, the group has ZERO items → return nothing
                            if (filteredItems.length === 0) return null;

                            return (
                                <table
                                    className="w-full border border-gray-200 rounded-lg"
                                    key={`${group.subject}-${group.city}`}
                                >
                                    <thead className="bg-gray-200 text-gray-700">
                                        <tr>
                                            <th className="py-2 px-4 border">#</th>
                                            <th className="py-2 px-4 border">{language ? "City" : "المحافظة"}</th>
                                            <th className="py-2 px-4 border">{language ? "Subject" : "المادة"}</th>
                                            <th className="py-2 px-4 border">{language ? "Certification" : "الشهادة"}</th>
                                            <th className="py-2 px-4 border">{language ? "Full Name" : "اسم المتقدم"}</th>
                                            <th className="py-2 px-4 border">Whatsapp</th>
                                            <th className="py-2 px-4 border">{language ? "Phone" : "المحمول"}</th>
                                            <th className="py-2 px-4 border">{language ? "Registered At" : "موعد التسجيل"}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredItems.map((user, index) => (
                                            <tr
                                                key={user.id}
                                                className={`transition duration-150 text-center text-black bg-white hover:bg-gray-50`}
                                            >
                                                <td className="py-2 px-4 border">{index + 1}</td>
                                                <td className="py-2 px-4 border">{user.city}</td>
                                                <td className="py-2 px-4 border">{user.subject.name}</td>
                                                <td className="py-2 px-4 border">{user.certification}</td>
                                                <td className="py-2 px-4 border">
                                                    {user.firstName} {user.secondName} {user.thirdName} {user.fourthName}
                                                </td>
                                                <td className="py-2 px-4 border">{`+2${user.whatsappNumber}`}</td>
                                                <td className="py-2 px-4 border">{`+2${user.phoneNumber}`}</td>
                                                <td className="py-2 px-4 border">
                                                    {cairoDate(user.created_at).split(",")[0].trim()}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            );
                        })}
                </div>
            </div>
        </div>
    )
};

export default EbdaEduWatomsTrainerRegistrations;